import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { Heading, Logo } from '../../';

export interface VipHeadingProps extends CommonProps {
    title?: string;
    invertFontColor?: boolean;
}

export const VipHeadingStyles = cva(
    'flex flex-col md:flex-row items-center text-center mb-14 md:mb-8 gap-8'
);

export const VipHeadingText = cva('mb-0 font-normal', {
    variants: { invertFontColor: { true: 'invert', false: '' } },
});

export const VipHeading = ({
    className,
    title,
    invertFontColor = false,
    testId = 'premium-heading',
    ...props
}: VipHeadingProps): JSX.Element => {
    return (
        <div
            className={twMerge(VipHeadingStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <Logo
                className="w-[211px] md:w-[142px]"
                invert={invertFontColor}
                venueId="vip"
            />
            <Heading
                as="h2"
                className={twMerge(VipHeadingText({ invertFontColor }))}
                size="h5"
            >
                {title}
            </Heading>
        </div>
    );
};
